import $ from "jquery";
import jsfix from "jsfix";

export default function () {}

const is_mobile =
  /iPhone/i.test(navigator.userAgent) ||
  /iPad/i.test(navigator.userAgent) ||
  /android/i.test(navigator.userAgent);

const has_video = $("video").length > 0;

if (has_video) {
  if (is_mobile) {
    $("body").prepend('<div class="video-background"></div>');
    $(".video-background").addClass("mobile_bg");
    $("video").hide();
  } else {
    $("video").show();
    //Add class to wrapper to block its default margin-top
    // 		$('.wrapper').addClass("nomargintop");
  }
}

jsfix.register("js-scroll-to", function ($el, to) {
  $el.click(function () {
    $("body,html").animate(
      {
        scrollTop: $(to).offset().top,
      },
      1000
    );
  });
});
